module.exports = __webpack_public_path__ + "static/img/icon_More@2x.570cf1c8.png";